import PropTypes from 'prop-types';
import './SurveyQuizQuestion.css';
import QuizTwoOptionsSelect from '../../../Details/components/Quiz/QuizTwoOptionsSelect';
import QuizStateSelect from '../../../Details/components/Quiz/QuizStateSelect';
import QuizCoverageInput from './SurveyQuizCoverageInput/SurveyQuizCoverageInput';
import QuizSelect from './SurveyQuizSelect/SurveyQuizSelect';
import SurveyQuizBar from './SurveyQuizBar';

const QuizMap = {
  "QuizTwoOptionsSelect": QuizTwoOptionsSelect,
  "QuizStateSelect": QuizStateSelect,
  "QuizCoverageInput": QuizCoverageInput,
  "QuizSelect": QuizSelect,
}

const QuizQuestion = props => {
  const {text, type, description, bottomDescription} = props.question
  let CurrentComponent = QuizMap[type];
  const showCoverageError = props.question.value === "funeral_cost" && props.funeralCostError;

  return (
    <div className={`surveyQuizQuestionBox flex-column ${props.questionI == props.currentSurveyQuestionI ? "d-block" : "d-none"}`}>
        {type != "SurveyDisqualified" && <SurveyQuizBar {...props} />}

        {type == "SurveyDisqualified" ? 
          <div className={`${props.questionI == props.currentSurveyQuestionI ? "d-flex" : "d-none"} 
                    flex-column justify-content-center questionContent
                    question${props.questionI} 
                    ${props.prevQuestionI != undefined && props.prevQuestionI < props.currentSurveyQuestionI ? "slideNextQAppearence" : props.prevQuestionI != undefined ? "slidePrevQAppearence":""}`}>
            <div className="infoText font-weight-500">Unfortunately, we are looking for information exclusively from those who have dealt with recent funeral costs.</div>
            <div className="infoText mt-2">We thank you for your willingness to take our survey.</div>
          </div>
        : 
          <div className={`${props.questionI == props.currentSurveyQuestionI ? "d-flex" : "d-none"} 
                    flex-column justify-content-center questionContent
                    question${props.questionI} 
                    ${props.prevQuestionI != undefined && props.prevQuestionI < props.currentSurveyQuestionI ? "slideNextQAppearence" : props.prevQuestionI != undefined ? "slidePrevQAppearence":""}`}>
            <div className="d-flex flex-column justify-content-center">
              <div className={`${props.question.textClass}`} dangerouslySetInnerHTML={{ __html: text }}></div>
              {description && <div className="fs-15 mw-400">{description}</div>}
            </div>
            <div className='w-100 mt-3'>
              {type != "QuizSurveyComplete" && <CurrentComponent 
                {...props.question} 
                {...props}
                surveyQuiz={true}
              />}
            </div>
              {!showCoverageError && bottomDescription && <div className="fs-15 mw-400">{bottomDescription}</div>}

              {showCoverageError && <div className="funeralCostError">Please enter a value $100 or more</div>}
          </div>}
    </div>
  );
};

QuizQuestion.propTypes = {
  currentSurveyQuestion: PropTypes.object.isRequired,
};

export default QuizQuestion;
